export default "__VITE_ASSET__BeQqNb8l__"